import SadCart from '@monofront/design-system/visuals/Icons/Old/SadCart';
import Button from '@monofront/design-system/components/Button';
import Magnifier from '@monofront/design-system/visuals/Icons/Old/Magnifier';
import { useRouter } from 'next/router';
import { isMobileApp } from '@utils/environment';
import { sendMessageToMobile } from '@utils/mobile';
import { useTranslations } from 'next-intl';
import { useAuthentication } from '@context/businessContainer';
import { RoutesEnum } from '@monofront/types';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';

interface IEmptyProducts {
  ctaLabel: string;
  text?: string;
  richText?: React.ReactNode;
}

const EmptyProducts: React.FC<IEmptyProducts> = ({
  ctaLabel,
  text,
  richText,
}) => {
  const router = useRouter();

  const { customer } = useAuthentication();
  const { getPath } = useLocalizedRoutes();

  const onClickButton = () => {
    if (isMobileApp) {
      sendMessageToMobile('goToRayons', {});
    } else {
      if (customer?.orderCount && customer?.orderCount > 0) {
        router.push('/pages/my-lists?tab=my-purchases');
      } else {
        router.push(getPath(RoutesEnum.ESSENTIALS_COLLECTION));
      }
    }
  };

  const tGlobal = useTranslations('Global');

  return (
    <>
      <div className="container">
        <SadCart />
        <div className="message">
          {richText ?? (
            <>
              <p>{tGlobal('oops')} </p>
              <p>{text}</p>
            </>
          )}
        </div>
        <div className="button-container">
          <Button
            variant="primary"
            hasMinWidth={false}
            onClick={onClickButton}
            dataTestId="EmptyProducts-Button-1"
          >
            <span>
              <Magnifier color="var(--black)" aria-hidden />
            </span>
            {ctaLabel}
          </Button>
        </div>
      </div>
      <style jsx>{`
        .container {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          margin-top: var(--space-8);
          margin-bottom: var(--space-8);
        }
        .message {
          max-width: 290px;
          text-align: center;
          margin-top: var(--space-2);
          margin-bottom: var(--space-3);
        }

        .button-container > :global(button) {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: var(--space-4);
        }

        .button-container > :global(button > span) {
          transition: 0.5s;
          margin: 0;
          display: flex;
          align-items: center;
          margin-right: var(--space-4);
        }

        .message :global(strong) {
          font-weight: var(--font-weight-base);
          display: inline-block;
          padding-bottom: var(--space-1);
        }
      `}</style>
    </>
  );
};

export default EmptyProducts;
